import { helpers } 		  from './theme/helpers.js';

import { hamburger } 	  from './theme/components/hamburger.js';
import { sliders } 		  from './theme/components/sliders.js';
import { gallery } 		  from './theme/components/gallery.js';
import { forms } 		  from './theme/components/forms.js';
import { modal } 		  from './theme/components/modal.js';
// import { popups } 		  from './theme/components/popup.js'; no needed - time expiration is in class-popup.php
// import { cookiesConsent } from './theme/components/cookiesConsent.js'; - už v samostatném souboru
import { mobileMenu }     from './theme/components/mobileMenu.js';
import { filters }     from './theme/components/filters.js';

import './theme/components/datepicker.js';

window.theme = {
	globals: {
		isTouch: typeof window !== 'undefined' && 'ontouchstart' in window,
		isTabActive: true,
		lastScroll: 0,
	},
	init: function () {
		var self = this;

		modal.init();
		//popups.init(); // no needed - time expiration is in class-popup.php
		//hamburger.init();
		sliders.init();
		gallery.init();
		forms.init();
		//cookiesConsent.init();
		mobileMenu.init();
		filters.init();

		self.smoothScroll.init();
		self.onloadClass();
		self.touch();
		//self.fixButtons();
		self.reservationForm();
		self.reservationIframe();
		self.showFulltext();
		self.showFulltextRooms();
		self.showAllProperties();
		self.lazyload();
		self.stickyKit();
	},
	onloadClass: function () {
		document.querySelector('body').classList.add('loaded');
	},
	touch: function () {
		var self = this;

		var touchClass = self.globals.isTouch === true ? 'touch-device' : 'pointer-device';
		document.querySelector('body').classList.add( touchClass );
	},
	getUrlParameter: function(sParam) {
		var sPageURL = window.location.search.substring(1),
			sURLVariables = sPageURL.split('&'),
			sParameterName,
			i;

		for (i = 0; i < sURLVariables.length; i++) {
			sParameterName = sURLVariables[i].split('=');

			if (sParameterName[0] === sParam) {
				return typeof sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
			}
		}

		return false;
	},
	showFulltext: function() {
		jQuery(document).ready(function($) {
			$('.view-fulltext').on('click', function(e) {
				e.preventDefault();

				var $this = $(this);
				var fullText = $this.next('.hidden-fulltext');

				$(this).prev('.more-ellipsis').hide();
				$this.hide();
				fullText.show();
			});
		});
	},
	showFulltextRooms: function() {
		jQuery(document).ready(function($) {
			$('.view-fulltext').on('click', function(e) {
				e.preventDefault();

				var shortText = $(this).closest('.short-text');
				var fullText = shortText.next('.full-text');

				shortText.hide();
				fullText.show();
			});
		});
	},
	showAllProperties: function() {
		jQuery( '.show-all-properties' ).on( 'click', function(){
			jQuery( this ).prev().find( '.item--hidden' ).removeClass( 'item--hidden' );
			jQuery( this ).addClass( 'hidden-fulltext' );
		});
	},
	reservationIframe: function() {
		var self = this,
			iframe = jQuery( '#previo-booking-iframe' ),
			string = iframe.attr( 'data-src' );



		if(iframe.length && string) {
			// var string = iframe.attr( 'data-src' );
			// var getData = self.getUrlParameter( 'datum' );
			// console.log( getData );

			if( self.getUrlParameter( 'hotId' ) ) {
				string = string.replaceAll( 'HID', self.getUrlParameter( 'hotId' ) );
			} else {
					string = string.replaceAll( '&hotId=HID', '' );
			}

			if( self.getUrlParameter( 'coupon' ) ) {
				string = string.replaceAll( 'booking.previo.app/stay', 'booking.previo.app/coupon');
			}

			if( self.getUrlParameter( 'arrival' ) ) {
				string = string.replace( 'ARR', self.getUrlParameter( 'arrival' ) );
			} else {
				string = string.replaceAll( '&arrival=ARR', '' );
			}

			if( self.getUrlParameter( 'departure' ) ) {
				string = string.replace( 'DEP', self.getUrlParameter( 'departure' ) );
			} else {
				string = string.replaceAll( '&departure=DEP', '' );
			}

			if( self.getUrlParameter( 'stayId' ) ) {
				string = string.replace( 'SID', self.getUrlParameter( 'stayId' ) );
			} else {
				string = string.replaceAll( '&stayId=SID', '' );
			}

			if( self.getUrlParameter( 'rid' ) ) {
				string = string.replaceAll( 'RID', self.getUrlParameter( 'rid' ) );
			} else {
				string = string.replaceAll( 'showRoomType=RID', '' );
			}

			if( self.getUrlParameter( 'hrid' ) ) {
				string = string.replaceAll( 'HRID', self.getUrlParameter( 'hrid' ) );
			} else {
				string = string.replaceAll( '&highlightRoomType=HRID', '' );
			}

			if( self.getUrlParameter( 'sid' ) ) {
				string = string.replaceAll( 'SID', self.getUrlParameter( 'sid' ) );
			} else {
				string = string.replaceAll( '&stayId=SID', '' );
			}

			if( self.getUrlParameter( 'numberOfAdults' ) ) {
				string = string.replaceAll( 'NOA', self.getUrlParameter( 'numberOfAdults' ) );
			} else {
				string = string.replaceAll( '&numberOfAdults=NOA', '' );
			}

			if( self.getUrlParameter( 'childAges' ) ) {
				string = string.replaceAll( 'CHA', self.getUrlParameter( 'childAges' ) );
			} else {
				string = string.replaceAll( '&childAges=CHA', '' );
			}

			var domain = string.split('?')[0];
			var stringAfterQuestionMark = string.split('?')[1];

			if(stringAfterQuestionMark.charAt( 0 ) === '&' )
				stringAfterQuestionMark = stringAfterQuestionMark.slice( 1 );

			string = domain + "?" + stringAfterQuestionMark;

			jQuery( '#previo-booking-iframe' ).attr( 'src', string );
		}
	},
	reservationForm: function() {
		var self = this;

		if( jQuery( '#reservation-picker-to' ).length ) {
			var today = new Date();
			var date = today.getFullYear()+'-'+(today.getMonth()+1)+'-'+today.getDate();

			const picker = new Litepicker({
				element: document.getElementById( 'reservation-picker-from' ),
				elementEnd: document.getElementById( 'reservation-picker-to' ),
				singleMode: false,
				// minDate: moment(),
				minDate: date,
				format: "DD.MM.YYYY",
				numberOfMonths: 2,
  				numberOfColumns: 2,
			});
		}
	},
	/*fixButtons: function() {
		var self = this;

		jQuery( 'main .button:not([type="submit"]), footer .button:not([type="submit"])' ).each( function(){
			if( jQuery( this ).parent().prop( 'tagName' ) != 'P' ) {
				jQuery( this ).wrap( '<p></p>' );
			}
		});
	},*/
	smoothScroll: {
		selector: 'a[href*="#"]',
		init: function () {
			var self = this;
			var scroll = new SmoothScroll(self.selector, {
				ignore: '[data-scroll-ignore]',
				topOnEmptyHash: false,
				speed: 1000,
				offset: 0,
				updateURL: false,
				easing: 'easeInOutCubic',
			});
		},
	},
	windowPosition: function () {
		return {
			x: window.pageXOffset || document.documentElement.scrollLeft,
			y: window.pageYOffset || document.documentElement.scrollTop,
		};
	},
	windowSizes: function () {
		return {
			width: Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0),
			height: Math.max(document.documentElement.clientHeight || 0, window.innerHeight || 0),
		};
	},
	onresize() {
		var self = this;
	},
	onscroll(position, previusPosition) {
		var self = this;

		var currentScroll = self.windowPosition()['y'];

		var fixedHeader = currentScroll > 100;
		var scrollUp = "scroll-up";
		var scrollDown = "scroll-down";
		var body = document.querySelector('body');

		if ( fixedHeader ) {
			body.classList.add('fixed-header');

			if( currentScroll >= 100 ) {
				if (currentScroll > self.globals.lastScroll && !body.classList.contains(scrollDown)) {
					// down
					body.classList.remove(scrollUp);
					body.classList.add(scrollDown);
				} else if (currentScroll < self.globals.lastScroll && body.classList.contains(scrollDown)) {
					// up
					body.classList.remove(scrollDown);
					body.classList.add(scrollUp);
				}
			} else {
				body.classList.remove(scrollUp);
				body.classList.remove(scrollDown);
			}

			self.globals.lastScroll = currentScroll;
		} else {
			document.querySelector('body').classList.remove('fixed-header');
		}
	},
	lazyload() {
		let lazyLoadInstance = new LazyLoad();
		lazyLoadInstance.update();
	},
	stickyKit() {
		let headerHeight = $("#site-header").height(),
			offset = headerHeight + 20;
		$(".stick-in-parent").stick_in_parent({
				offset_top: offset
		});
	},
};

jQuery(document).ready(function ($) {
	theme.init();

	setTimeout(function () {
		$(".page_loader").fadeOut("fast");
	}, 100)
});

window.addEventListener('scroll', function (e) {
	theme.onscroll();
});

window.addEventListener('resize', function (e) {
	theme.onresize();
});

window.onfocus = function () {
	theme.globals.isTabActive = true;
};

window.onblur = function () {
	theme.globals.isTabActive = false;
};

jQuery.fn.isOnScreen = function(){
    var win = jQuery(window);

    var viewport = {
        top : win.scrollTop(),
        left : win.scrollLeft()
    };
    viewport.right = viewport.left + win.width();
    viewport.bottom = viewport.top + win.height();

    var bounds = this.offset();
    bounds.right = bounds.left + this.outerWidth();
    bounds.bottom = bounds.top + this.outerHeight();

    return (!(viewport.right < bounds.left || viewport.left > bounds.right || viewport.bottom < bounds.top || viewport.top > bounds.bottom));
};

jQuery(document).ready(function() {
	var lang = document.documentElement.lang;
	jQuery.datepicker.setDefaults(jQuery.datepicker.regional[lang]);
});


$(document).ready(function() {
	//parallax scroll
	$(window).on("load scroll resize", function() {
		var parallaxElement = $(".img-parallax"),
			parallaxQuantity = parallaxElement.length,
			parallaxHeight = parallaxElement.height(),
			parallaxWrapper = parallaxElement.closest('.general-carousel-wrapper');

		if ($(window).width() < 768 ) {
			parallaxWrapper.css('max-height', parallaxHeight);
		} else {
			parallaxWrapper.css('max-height', 'none');
		}

		window.requestAnimationFrame(function() {
			for (var i = 0; i < parallaxQuantity; i++) {
				var currentElement = parallaxElement.eq(i),
					windowTop = $(window).scrollTop(),
					elementTop = currentElement.offset().top,
					elementHeight = currentElement.height(),
					viewPortHeight = window.innerHeight * 0.5 - elementHeight * 0.5,
					scrolled = windowTop - elementTop + viewPortHeight;
				currentElement.css({
					transform: "translate3d(0," + scrolled * .8 + "px, 0)"
				});
			}
		});
	});

	//tiles hover state
	$('.tiles a.link').on("touchstart", function (e) {
		"use strict"; //satisfy the code inspectors
		var item = $(this).find('.item'); //preselect the link
		if (item.hasClass('hover')) {
			return true;
		} else {
			item.addClass("hover");
			e.preventDefault();
			return false;
		}
	});
});

$(document).on('click', 'a:not(.filter-button)[href^="#"]', function (event) {
	event.preventDefault();
	var siteHeader = $("#site-header"),
	    topOffset = 0;

	if (siteHeader.length) {
		topOffset = siteHeader.height() + 20;
	}


	$('html, body').animate({
		scrollTop: $($.attr(this, 'href')).offset().top - topOffset
	}, 500);
});

$(document).ready(function() {
	var slidingInners = $('.tiles .item__inner--sliding');
	if (slidingInners.length > 0) {
		slidingInners.each(function(index) {
			var slidingInner = $(this);
			var title = $('.tiles .title').eq(index);
			var titleHeight = title.outerHeight() + 30;

			slidingInner.css('bottom', 'calc(-100% + ' + titleHeight + 'px)');
		});
	}
});

$(document).ready(function() {
	$('.faq-question').on('click', function() {
		var $faqItem = $(this).closest('.faq-item');
		var $faqToggle = $faqItem.find('.fa');
		$faqToggle.toggle();
		if ($faqItem.hasClass('open')) {
			$faqItem.removeClass('open');
			$faqItem.find('.faq-answer').slideUp();

		} else {
			$faqItem.addClass('open');
			$faqItem.find('.faq-answer').slideDown();
		}
	});
});

function getQueryParam(param) {
	var urlParams = new URLSearchParams(window.location.search);
	return urlParams.get(param);
}

var packageReservationLinks = document.querySelectorAll('.go-to-reservation');
if (packageReservationLinks.length > 0) {
	var hotId = getQueryParam('hotId');

	if (hotId) {
		packageReservationLinks.forEach(function(link) {
			var currentHref = link.getAttribute('href');
			if (currentHref.indexOf('hotId=') === -1) {
				link.setAttribute('href', currentHref + '&hotId=' + hotId);
			}
		});
	}
}

$(document).ready(function() {
	var reservationBarSquare = $('.reservation-bar--square');
	if (reservationBarSquare.length > 0) {
		if ($(this).scrollTop() > 1) {
			reservationBarSquare.addClass("scrolled");
		}
		$(window).on("scroll", function() {
			if ($(this).scrollTop() > 1) {
				reservationBarSquare.addClass("scrolled");
			} else {
				reservationBarSquare.removeClass("scrolled");
			}
		});

		reservationBarSquare.find('.info-btn').click(function (){
			$(this).next('.info-text').toggleClass('active');
			$(this).parent('.contact-info').toggleClass('active');
		});
	}
});

$(document).ready(function() {
	$('.back-to-top-button').click(function(event) {
		$('html, body').animate({ scrollTop: 0 }, 'slow');
	});
});

$(document).ready(function () {
	if ($(".escape-popup").length > 0) {
		$(document).on("mouseleave", function (event) {
			if (!Cookies.get("escape-popup-shown")) {
					if (!event.relatedTarget && !event.toElement) {
						$(".escape-popup").fadeIn(200).addClass('active');
						Cookies.set("escape-popup-shown", "true", { expires: 1 });
					}
			}
		});

		$(".escape-popup .close").on("click", function () {
			$(".escape-popup").hide().removeClass('active');;
		});
	}
});

$(document).ready(function () { // smap hotfix
const smap = document.querySelector('.szn-ending-popup-cover');
	if (smap) {
		smap.style.setProperty('display', 'none', 'important');
	}
});
